import { useState ,useContext} from "react";

import RightPanelItems from "./RightPanelItems";
import RightPanelHeader from "./RightPanelHeader";
import { GrMenu ,GrClose} from 'react-icons/gr'

import { MainContext } from "../../context/main-context";

const RightPanel = () => {
  const mainContext = useContext(MainContext);
  const handleRightPanel = (state) => {
    mainContext.toggleShowRightPanelMd(state);
    mainContext.toggleShowLeftPanel(false);
  }
  const [bookmark, setBookmark] = useState(false);
  return (<>
    {! mainContext.showRightPanelMd ? <GrMenu className="rp-toggle-btn" onClick={()=>handleRightPanel(true)}/> : <GrClose className="rp-toggle-btn" onClick={()=>handleRightPanel(false)}/>}
   

    <div className={mainContext.showRightPanelMd ? "right-panel-container right-panel-container-show" : "right-panel-container"}>
      <div className="rp-title-container">
        <RightPanelHeader
          isBookmark={bookmark}
          handleBookmark={() => {
            setBookmark(!bookmark);
          }}
        />
      </div>
      <div className="rp-items-container">
        <div className="rp-collapse">
          <RightPanelItems />
        </div>
      </div>
    </div>
    </>
  );
};

export default RightPanel;
